import { FlexboxGrid } from 'rsuite';
import './styles.scss'
export const commonFieldFormatter = (value: any, component: any) => {
    if (isNaN(+value)) return value;
    let val;
    if (value === "") {
        val = 0;
    } else {
        val = +value;
        val = val.toFixed(2)
    }
    let res: any = `${val}`;
    if (component.measure) {
        const containerClass = `common_field${component.contentAlign ? ` common_field__${component.contentAlign}` : ''}`
        res = <div className={containerClass}>
            <div className="common_field__value">{val}</div>
            <div className="common_field__measure">{component.measure}</div>
        </div>
    }

    return res
}

export const totalDistanceGainLossFormatter = (component: any) => {
    const { upstream: xgsUpstream, downstream: xgsDownstream } = component[component.valueID].xgspon
    const { upstream: gponUpstream, downstream: gponDownstream } = component[component.valueID].gpon
    const { measure } = component
    return <FlexboxGrid justify="end" align="middle" className='total_distance_gain_loss'>
        <FlexboxGrid.Item style={{paddingRight: "15px"}}>Gain/Loss:</FlexboxGrid.Item>
        <FlexboxGrid.Item>
            <FlexboxGrid align="bottom" justify="space-between" className='total_distance_gain_loss__res'>
                <FlexboxGrid.Item>XGS-PON {Math.abs(xgsUpstream.toFixed(2))}/{Math.abs(xgsDownstream.toFixed(2))} {measure}</FlexboxGrid.Item>
                <FlexboxGrid.Item>GPON {Math.abs(gponUpstream.toFixed(2))}/{Math.abs(gponDownstream.toFixed(2))} {measure}</FlexboxGrid.Item>
            </FlexboxGrid>
        </FlexboxGrid.Item>
    </FlexboxGrid>
}